import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./CustomFormModal.module.scss";

function CustomFormModal(props) {
  const form = React.cloneElement(props.form, { onSubmit: props.onSubmit });

  return (
    <Modal centered show={props.show} onHide={props.onHide}>
      <Modal.Header
        className={styles.modalHeader}
        closeButton
        closeVariant="white"
      >
        <Modal.Title>{props.modalTitle}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{form}</Modal.Body>
      {props.footer && (
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onLeftBtn}>
            {props.leftButton}
          </Button>
          <Button variant="primary" className={styles.btn} onClick={props.onRightBtn} disabled={!props.hasPaymentMethod}>
            {props.rightButton}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default CustomFormModal;
